import React, { useState, useEffect, useRef } from 'react'
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Modal,
    ModalBody,
    Progress,
    Table,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import PackageDialog from './PackageDialog'
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config'
import { Edit, Delete } from '@material-ui/icons'

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';


import PackageDelete from './PackageDelete'


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function PackageManagement() {

    const notification = useRef();
    const [progressVisible, setProgressVisible] = useState(true)
    const [progressValue, setProgressValue] = useState(8)
    const [open, setOpen] = useState(false);
    const [packageData, setPackageData] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [currentPackage, setcurrentPackage] = useState('');




    const notify = (msg, err) => {
        let color = err === true ? 'danger' : 'success'
        let options = {
            type: color,
            place: "tr",
            message: (
                <div>
                    <div>
                        <b>{err === true ? 'Error' : 'Success'}</b> -{msg}.
              </div>
                </div>
            ),
            icon: "tim-icons icon-bell-55",
            autoDismiss: 6
        };
        if(notification.current){
            notification.current.notificationAlert(options)
        }
    }


    const handleClickOpen = () => {

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setProgressValue(99)

        db.collection('zSystemStore').where('type', '==', 'topic').get().then((querySnapshot) => {
            let data = querySnapshot.docs.map((doc) => doc.data())
            setPackageData(data)
            setProgressVisible(false)

        })
    }, [])

    const deletePackage = (data) => {
        const afterDelete = packageData.filter(item => item.itemID !== data);
        setPackageData(afterDelete)

        db.collection("zSystemStore").doc(data).delete().then(() => {
            console.log('record deleted ')
            notify("Package Deleted Successfully",false);
        }).catch((error) => {
            notify(error.toString(),true);

            console.log('this is error ', error)
        })
    }

    return (
        <>

            {progressVisible ? 
                <>
                    <Progress color='info' value={progressValue} style={{ height: 4 }} />
                    <div className="content">
                    </div>
                </>
                :
                <div className="content">
                    <div className="react-notification-alert-container">
                        <NotificationAlert ref={notification} />
                    </div>
                    <Modal isOpen={deleteModal} color='primary' style={{ display: 'flex', flex: 1, top: -40, width: 250, backgroundColor: '#132639', objectFit: 'fill' }} >
                        <ModalBody style={{ width: '100%' }} size='sm'>
                            <PackageDelete
                                deletePackage={() => deletePackage(currentPackage)}
                                setDeleteModal={setDeleteModal}
                            ></PackageDelete>
                        </ModalBody>
                    </Modal>
                    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                        <PackageDialog currentPackage={currentPackage} setPackageData={setPackageData} notifi={notify} handleClose={handleClose} />
                    </Dialog>
                    <Row>
                        <Col md="12">
                            <Card >
                                <CardHeader >
                                    <Row>
                                        <Col sm={9} style={{ textAlign: 'center' }}>
                                            <CardTitle tag="h4" style={{ fontWeight: 300 }}>
                                                TOPIC MANAGEMENT
                                            </CardTitle>
                                        </Col>
                                        <Col sm={3}>

                                            <Button color='info' style={{float:'right'}} onClick={() => {
                                                // setCurrentQuiz('')
                                                setcurrentPackage('')
                                                handleClickOpen()
                                            }}>Add Topic</Button>

                                        </Col>

                                    </Row>

                                </CardHeader>


                                <CardBody >
                                    <Table className="tablesorter" >
                                        <thead className="text-primary">
                                            <tr>
                                                <th>Topic Title</th>
                                                {/* <th>Book Count</th>
                                                <th>Quiz Count</th> */}
                                                {/* <th>Question Count</th>
                                                <th>Price</th> */}
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {packageData.map(item => {
                                                // let status = user.status && [];
                                                // console.log(item.itemID);
                                                return (
                                                    <tr key={item.itemID}>
                                                        <td>{item.title}</td>
                                                        {/* <td>{item.numberOfBook}</td>
                                                        <td>{item.numberOfQuiz}</td> */}
                                                        {/* <td>{item.numberOfQuestions}</td>
                                                        <td>₹ {item.price}</td> */}


                                                        <td>
                                                            <Edit style={{color:'#247cf7', cursor: 'pointer'}}
                                                            onClick={() => {
                                                                setcurrentPackage(item)
                                                                handleClickOpen()

                                                            }}
                                                            />
                                                            <Delete
                                                                onClick={() => {
                                                                    setcurrentPackage(item.itemID)
                                                                    setDeleteModal(true)
                                                                }}
                                                                style={{ color: 'red', cursor: 'pointer' }}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            }
                                        </tbody>

                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>


                    {/* <Modal isOpen={editModal} style={{ display: 'flex', flex: 1, top: -200, minWidth:'85%' }} >
                <ModalBody className={styles.create__quiz_modal_body} >
                    <QuizEditModal notify={notify}
                        setquizData={setquizData} currentQuestion={currentQuestion} onClick={() => {
                            setEditModal(false)
                        }}>

                    </QuizEditModal>
                </ModalBody>
            </Modal> */}

                </div>
            }
        </>
    )
}

export default PackageManagement
